import { SortOrder } from '@/features/api';
import { FilterComparison } from '@/legacy/services/filters/filtersService';

export enum PayeeFilterType {
  Name = 0,
  Contact,
  Email,
  PadStatus,
  Type,
  ExcludeUniversalPayee,
}

export enum PayeeContactType {
  Customer,
  Supplier,
}

export enum PayeeContactTabsType {
  All = 'All Contacts',
  Suppliers = 'Suppliers',
  Customers = 'Customers',
}

export type PayeeFilterItem = {
  type: PayeeFilterType;
  comparison?: FilterComparison;
  value: string;
  valueTo?: string;
};

// In the backend, this is the same PayeeFilterType type, but it doesn't implement every field.
export enum PayeeSortType {
  Name = 0,
  Contact,
  Email,
  PadStatus,
}

export type PayeeSortItem = {
  type: PayeeSortType;
  order: SortOrder;
};
